import type { BroadcastConnectionStats } from "../../broadcast/sceneSync";

/** Cola previa al sink RTMP (ms) a partir de la cual la red no da abasto. */
export const DEGRADED_QUEUE_MS = 1000;

/** Bytes enviados sin ack del servidor RTMP a partir de los cuales la red no da abasto. */
export const DEGRADED_UNACKED_BYTES = 2_000_000;

/** Etiquetas legibles de los encoders que reporta el main (`kind`). */
const ENCODER_LABELS: Record<string, string> = {
  nvenc: "NVENC",
  mf: "Media Foundation",
  vt: "VideoToolbox",
};

/** true si alguna salida RTMP acumula cola o bytes sin ack: la red no da abasto. */
export function isOutputDegraded(
  outputs: BroadcastConnectionStats["outputs"],
): boolean {
  return outputs.some(
    (o) =>
      o.queueMs > DEGRADED_QUEUE_MS || o.unackedBytes > DEGRADED_UNACKED_BYTES,
  );
}

/** Mbps con 1 decimal a partir de kbps (6000 → "6.0"). */
export function formatMbps(bitrateKbps: number): string {
  return (bitrateKbps / 1000).toFixed(1);
}

/** Nombre legible del encoder; un `kind` desconocido se muestra tal cual. */
export function encoderLabel(kind: string): string {
  return ENCODER_LABELS[kind] ?? kind;
}
